import Body from './Body.container';

export default Body;
